export default __webpack_public_path__ + "static/media/Drive-Small.b6d92cce.png";